// Angular imports
import { NgModule } from '@angular/core';

// Devextreme imports
import {
    DxBoxModule,
    DxButtonModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDropDownButtonModule,
    DxFormModule,
    DxLoadPanelModule,
    DxNumberBoxModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxSelectBoxModule,
    DxTabsModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidatorModule
} from 'devextreme-angular';

// Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// Module imports
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared-module/shared.module';
import { ManagementCommonModule } from '../../../management-common/management-common.module';

// Component imports
import { WorkOrdersEditorComponent } from './work-orders-editor.component';
import { WorkOrderEditorJobInfoComponent } from './work-order-editor-job-info/work-order-editor-job-info.component';
import { WorkOrderEditorJobDetailComponent } from './work-order-editor-job-detail/work-order-editor-job-detail.component';
import { WorkOrdersHistoryComponent } from '../work-orders-history/work-orders-history.component';
import { WorkOrdersNotesEditorComponent } from '../work-orders-notes-editor/work-orders-notes-editor.component';
import { ManageWorkOrderProposalsComponent } from '../manage-work-order-proposals/manage-work-order-proposals.component';
import { ManageWorkOrderAuthorizationComponent } from '../manage-work-order-authorization/manage-work-order-authorization.component';
import { EditVendorForProposalComponent } from '../manage-work-order-proposals/edit-vendor-for-proposal/edit-vendor-for-proposal.component';
import { ManageQuotesComponent } from '../manage-work-order-proposals/manage-quotes/manage-quotes.component';
import { PropsalAcceptEditorComponent } from '../manage-work-order-proposals/propsal-accept-editor/propsal-accept-editor.component';
import { SelectVendorForProposalComponent } from '../select-vendor-for-proposal/select-vendor-for-proposal.component';
import { WorkOrderEditorReferenceSelectorComponent } from './work-order-editor-reference-selector/work-order-editor-reference-selector.component';
import { WorkOrderProposalHistoryComponent } from '../manage-work-order-proposals/work-order-proposal-history/work-order-proposal-history.component';
import { AddTemporaryVendorComponent } from '../select-vendor-for-proposal/add-temporary-vendor/add-temporary-vendor.component';
import { WorkOrderEmailAttachmentSelectorComponent } from '../work-order-email-attachment-selector/work-order-email-attachment-selector.component';

@NgModule({
    declarations: [
        WorkOrdersEditorComponent,
        WorkOrderEditorJobInfoComponent,
        WorkOrderEditorJobDetailComponent,
        WorkOrdersHistoryComponent,
        WorkOrdersNotesEditorComponent,
        ManageWorkOrderProposalsComponent,
        ManageWorkOrderAuthorizationComponent,
        EditVendorForProposalComponent,
        ManageQuotesComponent,
        PropsalAcceptEditorComponent,
        SelectVendorForProposalComponent,
        WorkOrderEditorReferenceSelectorComponent,
        WorkOrderProposalHistoryComponent,
        AddTemporaryVendorComponent,
        WorkOrderEmailAttachmentSelectorComponent
    ],
    imports: [
        CommonModule,
        CCCommonModule,
        SharedModule,
        CCDataGridFeaturesModule,
        ManagementCommonModule,
        DxBoxModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxSelectBoxModule,
        DxToolbarModule,
        DxFormModule,
        DxNumberBoxModule,
        DxTextBoxModule,
        DxTextAreaModule,
        DxDateBoxModule,
        DxPopupModule,
        DxTabsModule,
        DxDataGridModule,
        DxDropDownButtonModule,
        DxRadioGroupModule,
        DxValidatorModule
    ],
    exports: [
        WorkOrdersEditorComponent,
        WorkOrderEditorJobInfoComponent,
        WorkOrderEditorJobDetailComponent,
        WorkOrdersHistoryComponent,
        WorkOrdersNotesEditorComponent,
        ManageWorkOrderProposalsComponent,
        ManageWorkOrderAuthorizationComponent,
        EditVendorForProposalComponent,
        ManageQuotesComponent,
        PropsalAcceptEditorComponent,
        SelectVendorForProposalComponent,
        WorkOrderEditorReferenceSelectorComponent,
        WorkOrderProposalHistoryComponent,
        AddTemporaryVendorComponent,
        WorkOrderEmailAttachmentSelectorComponent
    ]
})
export class WorkOrderEditorModule {}
